import { Toaster } from "react-hot-toast";
import SalesHeader from "../../components/sales/SalesHeader";
import SalesStats from "../../components/sales/SalesStats";
import SalesTable from "../../components/sales/SalesTable";
import { useSalesStore } from "../../store/salesStore";
import { useEffect, useState } from "react";
import { decodeTokenService } from "../../services/decodeTokenService";
import { getOrdersbyUserId } from "../../services/orders/orderAxios";
import { Orders, Summary } from "./SalesPageInterface";
import { FilterOrdersType } from "../../components/buttons/ButtonFilterTypes";
import { LogisticState } from "../../types/order/logisticState";
import { PaidState } from "../../types/order/paidState";
import Loader from "../../components/common/Loader";
import { dictionary } from "../../utils/dictionary";
import { useAuth } from "../../context/AuthContext";


const SalesPage = () => {
  const { language } = useAuth();
  const { hasChanges, saveChanges, discardChanges } = useSalesStore();
  const [orders, setOrders] = useState<Orders>();
  const [filteredOrders, setFilteredOrders] = useState<Orders>();
  const [activeFilter, setActiveFilter] = useState<FilterOrdersType>("all");
  const [isLoading, setIsLoading] = useState(true);

  const calculateSummary = (ordersList: any[]) => {
    const total_value_with_discount_summary: number = ordersList.reduce((summary, order) => {
      return summary + order.total_value_with_discount;
    }, 0);

    const total_value_summary: number = ordersList.reduce((summary, order) => {
      return summary + order.total_value;
    }, 0);

    const total_units_summary: number = ordersList.reduce((summary, order) => {
      return summary + order.total_units;
    }, 0);

    const total_buyers_summary = ordersList.filter((order, index, self) =>
      index === self.findIndex((t) => t.customer_email === order.customer_email)
    ).length;

    const response: Summary = {
      total_buyers: total_buyers_summary,
      total_units: total_units_summary.toFixed(0),
      total_value: total_value_summary.toFixed(2),
      total_value_with_discount: total_value_with_discount_summary.toFixed(2)
    }
    return response;
  };

  const filterOrders = (filter: FilterOrdersType, ordersToFilter?: any[]) => {
    setActiveFilter(filter);
    const ordersList = ordersToFilter || orders?.orders;
    if (!ordersList) return;

    let filteredOrdersList;

    if (filter === "all") {
      filteredOrdersList = ordersList;
    } else if (filter === "unfulfilled") {
      filteredOrdersList = ordersList.filter((order) => order.logistic_state === LogisticState.CREATED);
    } else if (filter === "fulfilled") {
      filteredOrdersList = ordersList.filter((order) => order.logistic_state === LogisticState.IN_PROGRESS);
    } else if (filter === "paid") {
      filteredOrdersList = ordersList.filter((order) => order.payment_state === PaidState.PAID);
    } else if (filter === "pending") {
      filteredOrdersList = ordersList.filter((order) => order.payment_state === PaidState.PENDING);
    } else {
      filteredOrdersList = ordersList;
    }
    
    const newSummary = calculateSummary(filteredOrdersList);

    setFilteredOrders({
      orders: filteredOrdersList,
      summary: newSummary
    });
  };
  

  const handleOrderDeleted = (orderId: string) => {
    if (!orders) return;
    
    const updatedOrders = orders.orders.filter((order) => order.id.toString() !== orderId);
    
    const newOrders = {
      orders: updatedOrders,
      summary: calculateSummary(updatedOrders)
    };

    setOrders(newOrders);
    
    filterOrders(activeFilter, updatedOrders);
  };

  useEffect(() => {
    const userId = decodeTokenService.getUserIdFromToken() || "";
    getOrdersbyUserId(userId)
      .then((res) => {
        setOrders(res);
        setFilteredOrders(res);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-[#F5F6FA] p-16 font-['Plus_Jakarta_Sans']">
      <Toaster position="top-right" />
      <SalesHeader />
      {filteredOrders && (
        <>
          <SalesStats summary={filteredOrders.summary} />
          <SalesTable filterOrders={filterOrders} orders={filteredOrders.orders} activeFilter={activeFilter} onOrderDeleted={handleOrderDeleted} />
        </>
      )}

      {hasChanges && (
        <div className="fixed bottom-0 left-60 right-0 bg-white border-t border-gray-200 p-4 flex justify-end space-x-4">
          <button
            onClick={discardChanges}
            className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
          >
            {dictionary["undo-changes"][language]}
          </button>
          <button
            onClick={saveChanges}
            className="px-4 py-2 bg-[#4D88FF] text-white rounded-lg hover:bg-[#4D88FF]/90"
          >
            {dictionary["save-changes"][language]}
          </button>
        </div>
      )}
    </div>
  );
};

export default SalesPage;
